import React from 'react';
import PropTypes from 'prop-types';
import { realtimeDBKey } from 'constants/firebaseConstant';
import LocationInput from '../locationInput';

const CountryInput = ({ handleOnChange, selectedOption, error, id, name, placeholder, labelText }) => {
  const path = realtimeDBKey.COUNTRY;

  return (
    <LocationInput
      path={path}
      id={id}
      name={name}
      handleOnChange={handleOnChange}
      placeholder={placeholder}
      labelText={labelText}
      selectedOption={selectedOption}
      error={error}
      model={{ value: 'country_code', label: 'country' }}
    />
  );
};

CountryInput.propTypes = {
  handleOnChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.object,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  labelText: PropTypes.string,
};

CountryInput.defaultProps = {
  error: '',
  selectedOption: {},
  placeholder: '',
  labelText: '',
};

export default CountryInput;
